import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/react';

const tracesSampleRate = process.env.NODE_ENV === 'production' ? 0.1 : 1.0;

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: tracesSampleRate,
});

export default Sentry;
